export const formatRupiah = (n) => "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");

export const formatNumber = (n) => (Number(n) || 0).toLocaleString("id-ID");

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];

export const formatDate = (s) => {
  if (!s) return "-";
  const parts = String(s).slice(0, 10).split("-");
  if (parts.length !== 3) return s;
  const [y, m, d] = parts;
  return `${parseInt(d, 10)} ${MONTHS[parseInt(m, 10) - 1]} ${y}`;
};

export const formatDateTime = (s) => {
  if (!s) return "-";
  try {
    const d = new Date(s);
    return d.toLocaleString("id-ID", { timeZone: "Asia/Makassar", dateStyle: "medium", timeStyle: "short" }) + " WITA";
  } catch {
    return s;
  }
};

export const todayWITA = () => {
  const now = new Date();
  const wita = new Date(now.getTime() + (8 * 60 + now.getTimezoneOffset()) * 60000);
  return wita.toISOString().slice(0, 10);
};
